import { Router } from "@angular/router";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { SessionService } from "../../../../@core/session/session.service";
import { Store } from "../../../../@core/store/store";
import { AppLocalStorage } from "../../../../@core/utils/local-storage.util";
import { IntranetService } from "../service/intranet.service";
import { ApprovalDetailsComponent } from './approval-details/approval-details.component';
import { RequestConfirmationDialogComponent } from './request-confirmation-dialog/request-confirmation-dialog.component';
import { NbDialogService } from '@nebular/theme';
import { HeaderService } from "../../../../@theme/components/header/service/header.service";
import { RequestsForApprovalsLoadedState, RequestsForApprovalsLoadingErrorState, RequestsForApprovalsLoadingState } from "../../../../@theme/components/header/service/header.state";
import { DynamicStackService } from "../../dynamic-stack/service/dynamic-stack.service";
import { RemindersLoadedState, RemindersLoadingErrorState, RemindersLoadingState } from "../../dynamic-stack/service/dynamic-stack.state";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "ltts-request-for-approvals",
  templateUrl: "./request-for-approvals.component.html",
  styleUrls: ["./request-for-approvals.component.scss"],
})
export class RequestForApprovalsComponent implements OnInit {
  @ViewChild(ApprovalDetailsComponent)
  approvalDetailsComponent: ApprovalDetailsComponent;

  @Output() fetchRequest = new EventEmitter<any>();
  @Output() fetchAttendanceRequest = new EventEmitter<any>();
  @Output() fetchCarRequest = new EventEmitter<any>();
  @Output() fetchLeaveRequest = new EventEmitter<any>();
  @Output() fetchAccommodationRequest = new EventEmitter<any>();
  @Output() fetchSynergyRequest = new EventEmitter<any>();


  btnText: string = "View More";
  headerTitle: string = "Request for Approvals";
  reqForApprovalsData: any;
  reqForAttendanceApprovalsData: any;
  reqForLeaveApprovalData: any;
  reqForCarApprovalData: any;
  reqForAccommodationApprovalData: any;
  showDetailsCard: boolean;
  reqData: any;
  isRequestForApprovalsDataEmpty: boolean;
  userDataObj: any;
  emailID: any;
  employeeID: any;
  shimmerCard: number[] = [1, 2, 3, 4];
  requestsLoading: boolean;
  attendanceRequestLoading: boolean;
  leaveRequestLoading: boolean;
  carRequestLoading: boolean;
  accommodationRequestLoading: boolean;
  emptyDataForRequest: boolean = true;
  emptyAttendanceDataRequest: boolean = true;
  emptyLeaveDataRequest: boolean = true;
  emptyCarDataRequest: boolean = true;
  emptyAccommodationDataRequest: boolean = true;
  accountData: any ;
  selectedCategory: any;
  remindersData: any[] = [];
  remindersLoadingData: boolean = false;
  synergyApprovals: any;
  synergyLoadingData: boolean = false;
  isSynergyApprover: boolean = false;
  cmsbase_url: any;
  EmptyState: string;

  constructor(
    private intranetService: IntranetService,
    private sessionService: SessionService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private dialogService: NbDialogService,
    private headerService: HeaderService,
    private dynamicStackService: DynamicStackService
  ) {
  }

  @Input()
  set approvalData(value) {
    if (value) {
      this.reqForApprovalsData = value;
      this.emptyDataForRequest = this.reqForApprovalsData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set attendanceApprovalData(value) {
    if (value) {
      this.reqForAttendanceApprovalsData = value;
      this.emptyAttendanceDataRequest = this.reqForAttendanceApprovalsData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set leaveApprovalData(value) {
    if (value) {
      this.reqForLeaveApprovalData = value;
      this.emptyLeaveDataRequest = this.reqForLeaveApprovalData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set carApprovalData(value) {
    if (value) {
      this.reqForCarApprovalData = value;
      this.emptyCarDataRequest = this.reqForCarApprovalData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set accommodationApprovalData(value) {
    if (value) {
      this.reqForAccommodationApprovalData = value;
      this.emptyAccommodationDataRequest = this.reqForAccommodationApprovalData.every(
        (obj) => obj.totalTicketsCount === 0
      );
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set reminders(value) {
    if (value) {
      this.remindersData = value;
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set synergyApprovalData(value) {
    if (value) {
      const updatedSynergyApprovalData = {
        ...value, tickets: value.tickets?.map(ticket => ({
          ...ticket,
          categoryName: 'Synergy' // Replace with your logic or value
        }))
      };
      this.synergyApprovals = [updatedSynergyApprovalData];
      this.cdRef.detectChanges();
    }
  }

  @Input()
  set loadingData(value) {
    // if(value){
    this.requestsLoading = value;
    this.cdRef.detectChanges();
    // }
  }

  @Input()
  set attendanceLoadingData(value) {
    this.attendanceRequestLoading = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set leaveLoadingData(value) {
    this.leaveRequestLoading = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set carLoadingData(value) {
    this.carRequestLoading = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set accommodationLoadingData(value) {
    this.accommodationRequestLoading = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set remindersLoading(value) {
    this.remindersLoadingData = value;
    this.cdRef.detectChanges();
  }

  @Input()
  set synergyLoading(value) {
    this.synergyLoadingData = value;
    this.cdRef.detectChanges();
  }


  // @Output() fetchRequest = new EventEmitter();

  ngOnInit(): void {
    const me = this;
    this.accountData=AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA")
    const loginEmail = AppLocalStorage.get("ACCOUNT_DATA", "ACCOUNT_DATA");
    const profileData =  AppLocalStorage.get("PROFILE_DATA", "PROFILE_DATA");
    this.isSynergyApprover = Boolean(profileData?.isSynergyApprover);
    this.emailID = loginEmail.profile.email;

    this.employeeID = loginEmail.profile.employeeId;

    me.sessionService.userConfigData$.subscribe((data) => {
      if (data) {
        const emailId = data?.profile?.email;
        // me.fetchRequestForApprovalsData(emailId);
      }
    });
    //me.getRemindersListData(this.employeeID);
    this.cmsbase_url = environment.CMSURL_IMG;
    this.EmptyState = this.cmsbase_url+"wp-content/uploads/2025/05/EmptyState.png";
  }

  isSameValueForKey(arr: any[], key: string): boolean {
    if (arr.length === 0) return true; // Return true if the array is empty

    const firstValue = arr[0][key]; // Get the value of the key in the first object
    return arr.every((obj) => obj[key] === firstValue);
  }

  fetchRequestForApprovalsData(emailId: string) {
    const me = this;
    // me.fetchRequest.emit();
    // return
    // need to change above logic
    // emailId='Kancharikuntla.Anilreddy@ltts.com'
    me.headerService.fetchRequestsForApprovals(emailId).subscribe(
      (state: Store.State) => {
        if (state instanceof RequestsForApprovalsLoadingState) {
          // this.requestsLoading = true;
          return;
        }
        if (state instanceof RequestsForApprovalsLoadedState) {
          // this.requestsLoading = false;
          me.reqForApprovalsData = state.data.data;
          this.cdRef.detectChanges();

          // if (me.reqForApprovalsData.length) {
          //   me.isRequestForApprovalsDataEmpty = false;

          //   //count the totolrequest for each app
          //   this.reqForApprovalsData = this.reqForApprovalsData.map(app => ({
          //     ...app,
          //     totalRequests: app.tickets.reduce((total, ticket) => total + (ticket.requests ? ticket.requests.length : 0), 0)
          //   }));

          // } else {
          //   me.isRequestForApprovalsDataEmpty = true;
          // }
          // this.requestsLoading=false;
          //           me.reqForApprovalsData = state.data.data.applications;
          return;
        }
      },
      (state: RequestsForApprovalsLoadingErrorState) => {
        me.isRequestForApprovalsDataEmpty = true;
        this.requestsLoading = false;
        return;
      }
    );
  }

  fetchAttendanceRequestForApprovalData() {
    this.fetchAttendanceRequest.emit()
  }

  fetchCarRequestForApprovalData() {
    this.fetchCarRequest.emit()
  }

  fetchLeaveRequestForApprovalData() {
    this.fetchLeaveRequest.emit()
  }

  fetchAccommodationRequestForApprovalData() {
    this.fetchAccommodationRequest.emit()
  }

  fetchSynergyRequestForApprovalData() {
    this.fetchSynergyRequest.emit()
  }



  approveAll(event) {
    const reqBody = {
      category: event.categoryName,
      userId: this.employeeID,
      ticketID: "",
      employeeId: 0,
      fromDate: "",
      toDate: "",
    };

    this.dialogService.open(RequestConfirmationDialogComponent, {
      context: {
        title: 'Are you sure you want to approve all requests?',
        reqData: reqBody,
        action: 'approveAll'
      },
    }).onClose.subscribe((value) => {
      if (value) {
        this.fetchRequest.emit();
        // this.fetchRequestForApprovalsData(this.emailID);
      }
    });


  }

  approveRequest(selectedCategory) {
    const me = this;
    this.selectedCategory = selectedCategory;
    this.fetchRequest.emit();
    // this.fetchRequestForApprovalsData(this.emailID);
    return;

  }



  declineRequest(selectedCategory) {
    this.selectedCategory = selectedCategory;
    this.fetchRequest.emit();
    // this.fetchRequestForApprovalsData(this.emailID);
    return;

  }

  onClickRequest(data) {
    const me = this;
    if (data) {
      const reqData = data;
      reqData["loggedInUser"] = me.userDataObj?.employeeName;
      me.reqData = reqData;
      me.showDetailsCard = true;
    }
  }

  handleChildEvent(event) {
    const me = this;
    me.showDetailsCard = !event;
  }

  viewMore() {
    this.router.navigateByUrl("my-team/" + btoa(this.employeeID));
  }

  //  getRemindersListData(userId) {
  //       const me = this;
  //     me.dynamicStackService.getReminderData(userId).subscribe(
  //       (state: Store.State) => {
  //         if (state instanceof RemindersLoadingState) {
  //           me.remindersLoading = true;

  //           return;
  //         }
  //         if (state instanceof RemindersLoadedState) {
  //           me.remindersData = state?.data?.data;
  //           me.remindersLoading = false;
  //           //this.cdRef.detectChanges();
  //           return;
  //         }
  //       },
  //       (state: RemindersLoadingErrorState) => {
  //           me.remindersLoading = false;
  //           return;
  //       }
  //     );
  //   }
}
